import { render } from "./LinkableMessage.vue?vue&type=template&id=ab137e58"
import script from "./LinkableMessage.vue?vue&type=script&lang=js"
export * from "./LinkableMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__